import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Divider,
  HStack,
  VStack,
  Text,
  IconButton,
  DrawerOverlay,
  Center,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  FormControl,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { FiEye } from "react-icons/fi";
import { Link } from "react-router-dom";

interface UserApprovalModalProps {
  isOpen: boolean;
  onClose: () => void;
  submitRequest: (file: any) => void;
  request?: any;
}
const UserApprovalModal = ({
  isOpen,
  onClose,
  submitRequest,
  request,
}: UserApprovalModalProps) => {
  const [closeDrawerLoading, setCloseDrawerLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState("");

  const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:8008";
  const status = request?.status;

  const openDocument = () => {
    setIsDrawerOpen(true);
  };
  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const getModalTitle = () => {
    return "User Approval Request";
  };
  return (
    <Box
      display={"flex"}
      h={"100%"}
      w={"100%"}
      flexDirection={"column"}
      justifyContent={"flex-start"}
      alignContent={"center"}
      alignItems={"center"}
      textAlign={"left"}
    >
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{getModalTitle()}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} align="stretch">
              <Text fontSize="sm" fontWeight="bold" textAlign="center">
                {`Your profile details along with the document you upload here will be sent to the admin for approval`}
              </Text>
              <Link to="/user-profile"
              onClick={()=>{ onClose()}}>{"Click here to review your profile before requesting"}</Link>
              <Divider borderColor="gray.300" />
              <FormControl marginTop={4}>
                <FormLabel htmlFor="adminDocument" display="flex">
                  Upload your ID
                  <Text color="red" mx={1} fontSize={24}>
                    *
                  </Text>
                </FormLabel>
                <Box
                  border="1px solid"
                  borderColor="gray.300"
                  borderRadius="md"
                  padding={2}
                  _hover={{ borderColor: "gray.500" }}
                >
                  <Input
                    id="adminDocument"
                    name="adminDocument"
                    type="file"
                    accept="application/pdf"
                    onChange={(event) => {
                      const file = event?.target.files?.[0]?.name || "";
                      setFile(event?.target.files?.[0] || null);
                      setFileName(file);
                    }}
                    style={{ display: "none" }}
                  />
                  <Box
                    as="label"
                    htmlFor="adminDocument"
                    cursor="pointer"
                    display="block"
                    textAlign="center"
                    padding={2}
                    backgroundColor="gray.100"
                    borderRadius="md"
                    _hover={{ backgroundColor: "gray.200" }}
                  >
                    Choose Document
                  </Box>
                  {fileName && (
                    <Text mt={2} fontSize="sm" color={"green"}>
                      {fileName}
                    </Text>
                  )}
                </Box>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
              <Button
                colorScheme="blue"
                isLoading={closeDrawerLoading}
                mr={3}
                onClick={async () => {
                  setCloseDrawerLoading(true);
                  setTimeout(() => {
                    onClose();
                    submitRequest(file)
                    setCloseDrawerLoading(false);
                  }, 2000);
                }}
              >
                Request
              </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default UserApprovalModal;
